import { useEffect, useMemo, useState } from "react";

const DEFAULT_SERVER =
  process.env.REACT_APP_SERVER_URL ||
  process.env.SERVER_URL ||
  "https://rosemountstaffserver.onrender.com";

export const useServerSyncedTime = ({
  server = DEFAULT_SERVER,
  refreshMs = 60000,
  tickMs = 1000,
} = {}) => {
  const [serverBaseTime, setServerBaseTime] = useState(null);
  const [clientBaseTime, setClientBaseTime] = useState(null);
  const [liveNow, setLiveNow] = useState(Date.now());

  useEffect(() => {
    let syncInterval;

    const fetchServerTime = async () => {
      try {
        const res = await fetch(`${server}/api/time`);
        const data = await res.json();

        const timestamp = data?.now || Date.now();

        setServerBaseTime(timestamp);
        setClientBaseTime(Date.now());
      } catch (error) {
        console.error("Failed to fetch server time:", error);

        setServerBaseTime(Date.now());
        setClientBaseTime(Date.now());
      }
    };

    fetchServerTime();

    syncInterval = setInterval(fetchServerTime, refreshMs);

    return () => clearInterval(syncInterval);
  }, [server, refreshMs]);

  useEffect(() => {
    const tickInterval = setInterval(() => {
      setLiveNow(Date.now());
    }, tickMs);

    return () => clearInterval(tickInterval);
  }, [tickMs]);

  const effectiveTimestamp = useMemo(() => {
    if (serverBaseTime && clientBaseTime) {
      return serverBaseTime + (liveNow - clientBaseTime);
    }

    return Date.now();
  }, [serverBaseTime, clientBaseTime, liveNow]);

  return {
    effectiveTimestamp,
    effectiveDate: new Date(effectiveTimestamp),
    serverBaseTime,
    clientBaseTime,
  };
};
